{
  "nav": {
    "tools": "Strumenti",
    "openMenu": "Apri il menu",
    "subscription": "Abbonamento",
    "configuration": "Configurazione",
    "account": "Account",
    "administration": "Amministrazione",
    "ourTools": "I nostri strumenti",
    "pricing": "Prezzi",
    "faq": "FAQ"
  },
  "toolItems": {
    "flippingTool": "Strumento di flipping",
    "dropshipTool": "Strumento di dropship",
    "housingTool": "Strumento di housing",
    "inventoryAnalysisTool": "Strumento di analisi inventario",
    "snipeAlerts": "Avvisi snipe",
    "realmStats": "Statistiche del regno",
    "tsmListGenerator": "Generatore di liste TSM",
    "tsmProfileSetupGuide": "Guida alla configurazione del profilo TSM",
    "dashboard": "Dashboard",
    "classicDeals": "Classic Deals"
  },
  "configItems": {
    "regionRealm": "Configurazione regione e regno",
    "personal": "Configurazione personale",
    "discord": "Configurazione Discord"
  },
  "accountItems": {
    "settings": "Impostazioni"
  },
  "adminItems": {
    "stats": "Statistiche",
    "userInfo": "Informazioni utente",
    "goldSubscription": "Abbonamento oro",
    "itemLookup": "Ricerca articolo",
    "snipeAudit": "Audit snipe",
    "emailPreviews": "Anteprima e-mail"
  },
  "buttons": {
    "login": "Accedi",
    "logout": "Esci",
    "register": "Registrati",
    "registerNow": "Registrati ora",
    "signIn": "Accedi",
    "tryAgain": "Riprova",
    "goBack": "Indietro",
    "cancel": "Annulla",
    "deactivate": "Disattiva",
    "upgrade": "Aggiorna",
    "upgradeToPremium": "Passa a Premium",
    "upgradeNow": "Aggiorna ora",
    "unlockPremiumFeatures": "Sblocca le funzionalità Premium",
    "getMoreResultsAndFilters": "Ottieni più risultati e filtri",
    "goToConfig": "Vai alla configurazione",
    "save": "Save",
    "close": "Chiudi",
    "actions": "Azioni",
    "copyToClipboard": "Copia negli appunti",
    "saving": "Salvataggio…"
  },
  "loading": {
    "pleaseWait": "Attendi",
    "important": "Importante",
    "defaultWarning": "Non ricaricare la pagina durante questo processo.",
    "progressComplete": "{{percent}}% completato",
    "loadingAriaLabel": "Caricamento",
    "loadingProgressAriaLabel": "Avanzamento caricamento: {{percent}}%"
  },
  "error": {
    "somethingWentWrong": "Qualcosa è andato storto",
    "defaultMessage": "Si è verificato un errore! Attendi qualche secondo e ricarica la pagina",
    "fetchDataFailed": "Impossibile caricare i dati dell'asta"
  },
  "cancelDialog": {
    "title": "Annulla abbonamento",
    "confirmQuestion": "Sei sicuro di voler annullare il tuo abbonamento?",
    "loseAccessNotice": "Perderai l'accesso agli strumenti e non ti verrà più addebitato alcun pagamento futuro.",
    "warning": "Attenzione: una volta annullato l'abbonamento, perderai l'accesso agli strumenti al termine del periodo pagato e non rimborseremo gli abbonamenti annullati."
  },
  "dialog": {
    "confirm": "Conferma",
    "cancel": "Annulla"
  },
  "realmLimitPopup": {
    "title": "Limite regni superato",
    "description": "Hai selezionato più regni di vendita di quanti ne consenta l'abbonamento base. Modifica la configurazione o passa al premium."
  },
  "tooltipOverlay": {
    "upgradeTitle": "Passa a Premium",
    "upgradeSubtitle": "Sfrutta tutta la potenza di Flipping Pal",
    "enhancedFeatures": "Funzionalità avanzate",
    "exclusiveFeatures": "Funzionalità Premium esclusive",
    "alsoIncluded": "Incluso anche"
  },
  "footer": {
    "changelog": "Cronologia modifiche"
  },
  "logoAlt": "Flipping Pal - il tuo sito di flipping WoW preferito",
  "toggleNavAriaLabel": "Attiva/disattiva menu di navigazione",
  "mainNavAriaLabel": "Navigazione principale",
  "toolNavAriaLabel": "Navigazione strumenti",
  "simpleNavAriaLabel": "Navigazione semplice",
  "footerNavAriaLabel": "Navigazione a piè di pagina",
  "clipboard": {
    "copied": "Copiato negli appunti!",
    "tsmCopied": "Stringa TSM copiata negli appunti!",
    "exportCopied": "Codice di esportazione copiato con successo negli appunti.",
    "auctionatorCopied": "Liste della spesa di Auctionator copiate negli appunti!",
    "titleCopied": "{{title}} copiato negli appunti!",
    "copyFailed": "Impossibile copiare negli appunti"
  },
  "favorites": {
    "added": "Aggiunto ai preferiti",
    "removed": "Rimosso dai preferiti"
  },
  "enabled": "abilitato",
  "disabled": "disabilitato",
  "dataRefreshed": "Dati aggiornati! Trovate {{count}} opportunità.",
  "notFound": {
    "title": "Pagina non trovata"
  },
  "paymentSuccess": {
    "title": "Pagamento riuscito"
  },
  "pagination": {
    "summary": "Articoli totali trovati: {{total}} | Risultati per pagina: {{perPage}}",
    "summaryWithPages": "Articoli totali trovati: {{total}} | Risultati per pagina: {{perPage}} | Pagine totali: {{pages}}",
    "label": "Paginazione",
    "firstPage": "Prima pagina",
    "previousPage": "Pagina precedente",
    "nextPage": "Pagina successiva",
    "lastPage": "Ultima pagina",
    "pageAriaLabel": "Pagina {{page}}"
  },
  "stats": {
    "totalInvestment": "Investimento totale",
    "estimatedSellPrice": "Prezzo di vendita stimato",
    "profitAfterAHCut": "Profitto dopo la commissione AH"
  },
  "filters": {
    "searchItems": "Cerca articoli...",
    "watchVideoGuide": "Guarda la guida video",
    "watchVideoIntro": "Guarda il video introduttivo",
    "crossRealmVideoGuide": "Guida video dello strumento di flipping tra regni",
    "dropshipVideoGuide": "Guida video dello strumento di flipping dropship",
    "housingVideoGuide": "Guida video dello strumento housing",
    "downloadXLSX": "Scarica dati come XLSX",
    "getAuctionatorLists": "Ottieni le liste Auctionator",
    "quality": "Qualità",
    "selectQuality": "Seleziona qualità",
    "qualities": "qualità",
    "expansions": "Espansioni",
    "selectExpansions": "Seleziona espansioni",
    "expansionsMultiple": "espansioni",
    "sellingRealms": "Regni di vendita",
    "selectSellingRealms": "Seleziona regni di vendita",
    "sellingRealmsMultiple": "regni di vendita",
    "buyingRealms": "Regni di acquisto",
    "selectBuyingRealms": "Seleziona regni di acquisto",
    "buyingRealmsMultiple": "regni di acquisto",
    "categories": "Categorie",
    "selectCategories": "Seleziona categorie",
    "categoriesMultiple": "categorie",
    "sellRate": "Tasso di vendita",
    "saleAvg": "Media delle vendite",
    "haveCraftedItems": "Oggetti artigianali",
    "profitOnSaleAvg": "Profitto sulla media delle vendite",
    "saleAvgVsBuyPercent": "Media vendite vs acquisto %",
    "profitSellVsBuy": "Profitto (vendita vs acquisto)",
    "profitPercent": "Profitto %",
    "maxGoldBuyout": "Acquisto immediato max in oro",
    "ilvl": "ilvl",
    "activateProfitOnSaleAvg": "Attiva profitto sulla media delle vendite",
    "regionMarketValue": "Valore di mercato regionale",
    "regionHistorical": "Valore storico regionale",
    "modeRecalculate": "Ricalcola",
    "modeFilter": "Filtra",
    "modeRecalculateHint": "Le modifiche ai filtri ricalcolano i risultati sul server",
    "modeFilterHint": "Le modifiche ai filtri restringono solo i risultati già caricati",
    "modeAria": "Comportamento alla modifica dei filtri",
    "modeLabel": "Alla modifica dei filtri"
  },
  "table": {
    "noData": "Nessun dato trovato",
    "sellVsBuyTooltip": "La commissione del 5% della casa d'aste viene considerata nel calcolo del profitto",
    "toggleAllFavorites": "Attiva/disattiva tutti i preferiti",
    "clickToCopy": "Clicca per copiare: {{name}}",
    "priceAfterAHCut": "Prezzo dopo commissione AH: {{price}}",
    "noCompetition": "Nessuna concorrenza",
    "noCompetitionTooltip": "Nessun'inserzione nota nel regno di vendita.",
    "population": "Popolazione: {{population}}",
    "viewOnWowhead": "Visualizza {{name}} su Wowhead",
    "addToFavorites": "Aggiungi ai preferiti",
    "removeFromFavorites": "Rimuovi dai preferiti",
    "sessionExpiredFavorite": "Sessione scaduta. Effettua nuovamente il login.",
    "failedToUpdateFavorite": "Impossibile aggiornare il preferito",
    "addSnipeAlert": "Aggiungi avviso snipe",
    "editSnipeAlert": "Modifica avviso snipe",
    "headers": {
      "itemName": "Nome oggetto",
      "category": "Categoria",
      "ilvl": "ilvl",
      "sellRate": "Tasso di vendita",
      "expansion": "Espansione",
      "quality": "Qualità",
      "extraStats": "Stat extra",
      "saleAvg": "Vendita media",
      "regionMarketValue": "VM regione",
      "saleAvgVsBuy": "Vendita media vs Acquisto",
      "sellVsBuy": "Vendita vs Acquisto",
      "sellPrice": "Prezzo vendita",
      "sellRealm": "Regno vendita",
      "buyPrice": "Prezzo acquisto",
      "buyRealm": "Regno acquisto"
    },
    "columnsTitle": "Colonne",
    "columnsReset": "Reimposta",
    "columnsDragToReorder": "Trascina per riordinare",
    "columnsToggleVisibility": "Clicca l'occhio per cambiare la visibilità",
    "columnSettings": "Impostazioni colonne",
    "dragReorder": "Trascina per riordinare {{column}}",
    "hideColumn": "Nascondi {{column}}",
    "showColumn": "Mostra {{column}}",
    "rowActions": "Azioni riga",
    "actions": {
      "selectionSection": "Selezione",
      "pinSection": "Fissa in alto",
      "selectPage": "Seleziona pagina",
      "deselectPage": "Deseleziona pagina",
      "selectAll": "Seleziona tutto",
      "deselectAll": "Deseleziona tutto",
      "sortFavorites": "Fissa preferiti",
      "sortSnipes": "Fissa avvisi snipe",
      "sortSelected": "Fissa selezionati",
      "columnSettings": "Impostazioni colonne..."
    },
    "sortHint": "Clicca per ordinare",
    "sortHintMulti": "Clicca per ordinare · Maiusc+clic per ordinamento secondario",
    "selectRow": "Seleziona {{name}}",
    "emptyFiltered": "Nessun oggetto corrisponde ai filtri attuali",
    "emptyResetFilters": "Reimposta i filtri",
    "emptyUpdating": "È in corso un aggiornamento della regione — i nuovi dati arriveranno a breve."
  },
  "multipleSelect": {
    "noResults": "Nessun risultato trovato",
    "selectAll": "Seleziona tutto",
    "clearAll": "Cancella tutto",
    "selectOption": "Seleziona un'opzione",
    "selectMultipleOptions": "Seleziona più opzioni",
    "selected": "selezionato/i",
    "searchOptions": "Cerca opzioni",
    "noItemsSelected": "Nessun elemento selezionato",
    "search": "Cerca...",
    "items": "elementi"
  },
  "hierarchicalSelect": {
    "selectAll": "Seleziona tutto",
    "clearAll": "Cancella tutto",
    "expand": "Espandi",
    "collapse": "Comprimi",
    "selected": "selezionato/i",
    "noItemsSelected": "Seleziona categorie...",
    "items": "categorie",
    "triggerAriaLabel": "Seleziona {{items}}. {{count}} selezionati."
  },
  "hoverChart": {
    "high": "Alto:",
    "low": "Basso:",
    "avg": "Media:"
  },
  "tokenDisplay": {
    "label": "Gettone WoW",
    "signalBuy": "Segnale di acquisto — il prezzo è attualmente favorevole",
    "signalWait": "Attendi — il prezzo probabilmente continuerà a scendere",
    "signalHold": "Mantieni — nessuna tendenza chiara al momento",
    "loading": "Caricamento...",
    "error": "Errore",
    "priceHistory": "Storico prezzi 14 giorni",
    "high": "Alto: ",
    "low": "Basso: ",
    "avg": "Media: ",
    "momentum": "Momentum",
    "slowing": "In rallentamento ({{steps}})",
    "atCap": "Al limite dell'1%",
    "steps": "{{count}} passo",
    "stepsPlural": "{{count}} passi"
  },
  "nextUpdate": {
    "nextDataUpdate": "Prossimo aggiornamento dei dati",
    "dataSourceStatus": "Stato delle fonti dati",
    "tsmData": "Dati TSM:",
    "blizzardRealm": "Regno Blizzard:",
    "liveUpdates": "Aggiornamenti live:",
    "connected": "Connesso",
    "reconnecting": "Riconnessione...",
    "retry": "Riprova",
    "autoRefresh": "Aggiornamento automatico:",
    "autoRefreshEnabled": "La pagina si aggiornerà automaticamente quando sono disponibili nuovi dati",
    "autoRefreshDisabled": "Clicca l'icona di aggiornamento quando i nuovi dati sono pronti",
    "loadingStatus": "Caricamento stato dati...",
    "viewStatus": "Visualizza stato fonti dati",
    "refreshData": "Aggiorna dati",
    "reloading": "Ricaricamento",
    "liveUpdatesConnected": "Aggiornamenti live connessi",
    "liveUpdatesReconnecting": "Riconnessione...",
    "tsmFresh": "Dati TSM aggiornati (< 24h)",
    "tsmStale24": "Dati TSM in scadenza (24-25h)",
    "tsmStale25": "Dati TSM obsoleti (> 25h)",
    "toggleAutoRefresh": "Attiva/disattiva aggiornamento automatico"
  },
  "regionUpdateProgress": {
    "updating": "Aggiornamento dati regione",
    "realmsProgress": "{{updated}}/{{total}} regni ({{percent}}%)",
    "autoRefresh": "I dati si aggiorneranno automaticamente quando pronti",
    "reloadPartial": "Dati parziali disponibili — carica ora"
  },
  "filterFlyout": {
    "filtersButton": "Filtri",
    "loadingPresets": "Caricamento...",
    "selectPreset": "Seleziona preset...",
    "presetsSection": "Preset",
    "save": "Salva",
    "update": "Aggiorna",
    "delete": "Elimina",
    "export": "Esporta",
    "import": "Importa",
    "importPreset": "Importa preset…",
    "presetNamePlaceholder": "Nome preset...",
    "shareCode": "Condividi questo codice:",
    "copy": "Copia",
    "done": "Fatto",
    "pasteCodePlaceholder": "Incolla codice qui...",
    "applyFilters": "Applica filtri",
    "resetFilters": "Reimposta filtri",
    "refreshNow": "Aggiorna ora",
    "reset": "Reimposta",
    "deletePresetTitle": "Elimina preset",
    "deletePresetMessage": "Vuoi davvero eliminare questo preset? L'operazione non può essere annullata."
  },
  "discord": {
    "title": "Integrazione Discord",
    "description": "Collega il tuo account Discord per ricevere notifiche personalizzate e aggiornamenti dal nostro bot.",
    "accountLinked": "Account Discord collegato",
    "connectedAs": "Connesso come:",
    "unlink": "Scollega",
    "dmVerifiedBadge": "DM verificati: Il tuo Discord può ricevere notifiche dal nostro bot.",
    "dmVerificationTitle": "Verifica DM richiesta",
    "dmVerificationDesc": "Per abilitare le notifiche, dobbiamo confermare che il nostro bot possa inviarti messaggi diretti. Assicurati di avere i DM abilitati per almeno un server che condividi con il nostro bot.",
    "sendVerificationCode": "Invia codice di verifica al mio Discord",
    "sendingCode": "Invio codice...",
    "codeSentInstructions": "Controlla i tuoi DM Discord per un codice a 6 cifre dal nostro bot. Se non hai ricevuto un DM, controlla nelle impostazioni sotto Contenuto e Social > Permessi sociali che i messaggi diretti siano attivati.",
    "enterCodePlaceholder": "Inserisci codice a 6 cifre",
    "verify": "Verifica",
    "resendCode": "Rinvia codice",
    "notificationSettings": "Impostazioni notifiche",
    "verifyDmsFirst": "(verifica prima i DM)",
    "botFeaturesAvailable": "Funzionalità bot disponibili: Ora puoi ricevere messaggi privati per aggiornamenti di regione, snipe di oggetti e pet, snipe iLvl BoE e prezzo del token WoW.",
    "notConnected": "Non connesso: Collega il tuo account Discord per abilitare le notifiche e le funzionalità del bot.",
    "connectingToDiscord": "Connessione a Discord...",
    "linkAccount": "Collega account Discord",
    "regionUpdateLabel": "Notifiche aggiornamento regione",
    "regionUpdateDesc": "Ricevi notifiche quando i dati delle aste vengono aggiornati per le tue regioni selezionate.",
    "sendTestDm": "Invia DM di prova",
    "sendingTest": "Invio in corso…",
    "sendTestWebhook": "Prova",
    "testMessageHint": "Invia un messaggio di prova per confermare che la consegna su Discord funzioni senza attendere uno snipe reale.",
    "categoriesTitle": "Categorie di notifica",
    "categoriesDesc": "Instrada gli avvisi di snipe verso canali Discord diversi. Ogni categoria ha il proprio URL webhook e la propria modalità di menzione.",
    "categoriesPremiumHint": "Le categorie aggiuntive richiedono un abbonamento premium.",
    "categoryNamePlaceholder": "Nome della categoria",
    "webhookUrlPlaceholder": "https://discord.com/api/webhooks/...",
    "mentionLabel": "Menzione:",
    "defaultLabel": "Predefinita",
    "defaultCategoryTitle": "Categoria predefinita",
    "noWebhookSet": "nessun webhook impostato",
    "setAsDefault": "Imposta come predefinita",
    "edit": "Modifica",
    "delete": "Elimina",
    "add": "Aggiungi",
    "addCategory": "+ Aggiungi categoria",
    "deleteCategoryTitle": "Elimina categoria",
    "deleteCategoryMessage": "Vuoi davvero eliminare la categoria \"{{name}}\"? Gli avvisi assegnati useranno la categoria predefinita."
  },
  "csvExport": {
    "title": "Esporta CSV",
    "noItems": "Nessun elemento disponibile.",
    "copy": "Copia negli appunti",
    "copied": "CSV copiato negli appunti!",
    "copyFailed": "Copia non riuscita",
    "download": "Scarica CSV"
  },
  "updateBanner": {
    "title": "Aggiornamento disponibile",
    "description": "Una nuova versione è pronta.",
    "reload": "Ricarica",
    "dismiss": "Ignora"
  },
  "premiumPreviewBanner": {
    "title": "Hai accesso completo a Premium",
    "dayLeftOne": "1 giorno rimanente",
    "daysLeft": "{{count}} giorni rimanenti",
    "dismiss": "Ignora"
  },
  "tour": {
    "start": "Avvia il tour di questa pagina"
  },
  "filterSidebar": {
    "profitRange": "Intervallo profitto",
    "crafted_include": "Tutti gli oggetti",
    "crafted_excluded": "Escludi crafted",
    "crafted_exclusive": "Solo crafted",
    "showPositiveSaleAvgVsBuy": "Solo vendita media positiva vs acquisto",
    "presetClickToDeselect": "Clicca per deselezionare il preset",
    "collapseSidebar": "Comprimi filtri",
    "expandSidebar": "Espandi filtri"
  },
  "dashboard": {
    "loadError": "Impossibile caricare i dati della dashboard. Controlla la connessione e riprova.",
    "greeting": {
      "morning": "Buongiorno",
      "afternoon": "Buon pomeriggio",
      "evening": "Buonasera"
    },
    "subtitle": "Ecco cosa sta succedendo nella casa d'aste oggi.",
    "kpi": {
      "opportunities": "Opportunità"
    },
    "topOpportunities": {
      "title": "Migliori opportunità",
      "viewAll": "Vedi tutto",
      "itemsFound": "oggetti trovati su",
      "realms": "regni",
      "openTool": "Apri strumento flipping",
      "ilvl": "ilvl",
      "sellRate": "tasso di vendita",
      "tabFastSelling": "Fast Selling",
      "tabTopBuys": "Top Buys",
      "sellRateMin": "Sell Rate ≥",
      "buyBelowPct": "Buy Below",
      "noItems": "No items match the current filters",
      "saveFailed": "Impossibile salvare le impostazioni. È stato ripristinato l'ultimo valore salvato.",
      "saved": "Salvato",
      "sellRateTooltip": "Il tasso di vendita è su una scala da 0 a 1: la quota di aste pubblicate che vengono effettivamente vendute ogni giorno. 0,1 ≈ 10% degli annunci."
    },
    "recentSnipes": {
      "title": "Snipe recenti",
      "monitoringRealms": "Monitorando {{count}} regni",
      "vsTarget": "vs obiettivo",
      "itemsMonitored": "oggetti monitorati",
      "configureAlerts": "Configura avvisi",
      "noSnipes": "Nessuno snipe rilevato questo ciclo",
      "saved": "risparmiato"
    },
    "topRealms": {
      "title": "Top Realms",
      "sortPopVsAuctions": "Population vs Auctions",
      "sortPriceRatio": "Price Ratio",
      "sortNumAuctions": "Number of Auctions",
      "viewRealmStats": "Vedi statistiche dei regni"
    },
    "quickAccess": {
      "title": "Accesso rapido"
    },
    "onboarding": {
      "title": "Per iniziare",
      "progress": "{{done}}/{{total}} completati",
      "hide": "Nascondi checklist",
      "steps": {
        "realms": "Configura i tuoi regni",
        "preset": "Crea un preset di filtri iniziale",
        "flipping": "Esegui la tua prima scansione di flipping",
        "discordLink": "Collega il tuo account Discord",
        "snipe": "Configura gli avvisi snipe",
        "discordJoin": "Unisciti al server Discord"
      },
      "createPreset": "Crea preset",
      "creatingPreset": "Creazione…",
      "starterPresetName": "Starter",
      "configureRealmsFirst": "Configura prima i tuoi regni per creare un preset",
      "presetLimitReached": "Hai raggiunto il limite di preset salvati",
      "createPresetFailed": "Impossibile creare il preset. Riprova."
    },
    "activity": {
      "title": "Attività",
      "timeAgoLess1m": "<1m fa",
      "timeAgoMinutes": "{{count}}m fa",
      "timeAgoHours": "{{count}}h fa",
      "dataRefreshed": "Dati aggiornati — {{n}} opportunità trovate",
      "realmDataUpdated": "Dati regni {{region}} aggiornati",
      "waitingForData": "In attesa del primo aggiornamento dati…",
      "snipeAlertsActive": "Gli avvisi snipe sono attivi e monitorano i tuoi regni",
      "tokenTracked": "Il prezzo del WoW Token viene monitorato ogni 20 minuti"
    }
  },
  "versionSwitcher": {
    "label": "Game version",
    "retail": "Retail",
    "classicEra": "Classic Era",
    "switchFailed": "Failed to switch game version"
  },
  "classicDeals": {
    "title": "Classic Deals",
    "subtitle": "Buy items listed far below the next-cheapest copy on the same realm, then relist for a profit.",
    "region": "Region",
    "realms": "Realms",
    "selectRealms": "Select realms",
    "realmsSelected": "realms selected",
    "saveRealms": "Save realms",
    "findDeals": "Find deals",
    "loading": "Loading…",
    "selectRealmFirst": "Select at least one realm first",
    "saveFailed": "Failed to save realms",
    "realmsSaved": "Realms saved",
    "fetchFailed": "Failed to load deals",
    "noDeals": "No deals found for the selected realms.",
    "emptyPrompt": "Select your realms and click Find deals.",
    "colItem": "Item",
    "colRealm": "Realm",
    "colLowest": "Lowest",
    "colNext": "Next",
    "colProfit": "Profit",
    "colGap": "Gap",
    "colQty": "Qty",
    "colSaleRate": "Sale rate"
  },
  "backToTop": "Torna su",
  "slider": {
    "min": "Min",
    "max": "Max",
    "minAriaLabel": "Valore minimo",
    "maxAriaLabel": "Valore massimo",
    "numericInput": "Campo numerico {{label}}"
  },
  "inputBox": {
    "clear": "Cancella input",
    "required": "obbligatorio"
  },
  "auctionator": {
    "title": "Liste della spesa Auctionator",
    "account": "Account:",
    "allAccounts": "Tutti gli account",
    "noItems": "Nessun oggetto disponibile per l'account selezionato."
  },
  "popup": {
    "getTitle": "Ottieni {{title}}",
    "content": "Contenuto",
    "noContent": "Nessun contenuto disponibile",
    "copyTitle": "Copia {{title}}",
    "copyContent": "Copia contenuto",
    "titleContent": "Contenuto di {{title}}",
    "videoContent": "Contenuto video",
    "videoNotSupported": "Il tuo browser non supporta il tag video."
  },
  "snipePopup": {
    "ariaLabel": "Avviso snipe per {{name}}",
    "titleItem": "Avviso snipe oggetto",
    "titlePet": "Avviso snipe mascotte",
    "maxBuyoutPrice": "Prezzo massimo di acquisto immediato",
    "pricePlaceholder": "es. 500g o 500g 50s",
    "saving": "Salvataggio...",
    "updateAlert": "Aggiorna avviso",
    "setAlert": "Imposta avviso"
  },
  "refreshingData": "Aggiornamento dei dati...",
  "toolAccess": {
    "subscriptionRequired": "Hai bisogno di un abbonamento attivo per usare questo strumento!",
    "premiumRequired": "Hai bisogno di un abbonamento premium attivo per usare questo strumento!"
  }
}
